import React, { useState, useRef } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import QRCode from "react-qr-code";
import ErrorAlert from '../Alerts/ErrorAlert';
import imgCheck from "./img/check.png"
import { RenderIf } from '../utils/RenderIf';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';

function ModalConfirmation({ sendStatus, dataClientSelected, formatDataEmail, setResponseQr, setPageLoader, orderCode, orderNumber, total, change, setChange, totaltopay, invoiceTips, microsModule, datatransaction_code, order_id, printOrder, isPointsPayment = false, pointsTotal = 0 }) {
    const [show, setShow] = useState(true);
    const [email, setEmail] = useState(dataClientSelected?.email || '');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let routeQr = process.env.REACT_APP_ENVIROMENT === "development" ? "https://smartpay-landing-dev.herokuapp.com/order/" + orderCode + "/branchoffice/" + branchoffice.id : "https://smartpay.ai/order/" + orderCode + "/branchoffice/" + branchoffice.id
    let user = JSON.parse(localStorage.getItem('user'));
    const [copyMe, setCopyMe] = useState(false);
    const [ccEmail, setCcEmail] = useState(user?.email || '');

    const newOrder = () => {
        let message = isPointsPayment ? "Gracias por su canje." : "Gracias por su compra."
        let title = isPointsPayment ? "Canje exitoso" : "Transaccion exitosa"
        let icon = 'success'

        setChange(0)
        setPageLoader(1)
        setResponseQr(false)
        ErrorAlert(message, title, icon)
        localStorage.removeItem('client_data');
        localStorage.removeItem('addressNowLocation');
        updatePage()
    }
    console.log(routeQr);

    const updatePage = () => {
        window.location.reload()
    }


    const [current, setCurrent] = useState(0);
    const videoRef = useRef(null);
    const [videoList, setVideoList] = useState(() => {
        if (localStorage.getItem('publicity') !== null && localStorage.getItem('publicity') !== undefined && localStorage.getItem('publicity') !== '') {
            return JSON.parse(localStorage.getItem('publicity'))
                .filter(item => item.type === 'survey')
                .map(item => item.video_url);
        } else {
            return []
        }
    });

    const handleEnded = () => {
        // Go to next video or loop to the first
        setCurrent((prev) => (prev + 1 < videoList.length ? prev + 1 : 0));
    };

    const videoView = () => {
        return (
            <div class="video-wrapper">
                <video
                    autoplay
                    playsinline
                    ref={videoRef}
                    key={videoList[current]}
                    src={buildCloudinaryImageUrl({ url: videoList[current], type: "video", width: 720, quality: "auto" }) || videoList[current]}
                    controls={false}
                    autoPlay
                    onEnded={handleEnded}
                    muted
                    loop={videoList.length === 1}
                ></video>
            </div>

        )
    }

    const detailsOrder = () => {
        const pointsLabel = `${pointsTotal} pts`;
        return (<>


            <div id="accountsContainer" style={{ maxWidth: 500, width: '100%', }}>


                <div >
                    <div className="bg-white rounded-2xl-bs overflow-hidden h-100">
                        {/* Header */}
                        <div className="bg-teal-600 text-white p-4">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="fw-normal h4"><i class="fa-solid fa-receipt"></i> Orden:{orderNumber}</span>
                                <div className="text-end">
                                    <p className="fs-4 fw-bold lh-1 mb-0" translate='no'>{isPointsPayment ? pointsLabel : `$${totaltopay.toFixed(2)}`}</p>
                                </div>
                            </div>
                            <p className="fs-7 fw-light mb-0  text-end">{isPointsPayment ? "Puntos canjeados" : "Total pagado"}</p>
                        </div>

                        {/* Content Card */}
                        <div className="mx-2 mb-1 border border-gray-200-bs rounded-2xl-bs p-3 mt-2">
                            {/* Checkmark */}
                            <div className="d-flex justify-content-center mb-3">
                                <div className="rounded-circle d-flex align-items-center justify-content-center bg-teal-100"
                                    style={{ width: 56, height: 56 }}>
                                    {/* Inline check icon (puedes usar Bootstrap Icons si prefieres) */}
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                                        className="text-teal-600" stroke="currentColor" strokeWidth="3">
                                        <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>

                            {/* Title */}
                            <h2 className="text-center text-teal-600 fs-5 fw-semibold mb-2">
                                {isPointsPayment ? "Canje de puntos aprobado" : <>
                                Transacción Aprobada
                                </>}
                            </h2>

                            {/* Divider */}
                            <div className="border-bottom border-1 border-dashed-bs border-gray-300-bs "></div>
                            <div className="m-3 d-flex align-items-center justify-content-center ">

                                <QRCode value={routeQr}
                                    size={140}
                                    bgColor="#ffffff"
                                    fgColor="#000000"
                                    level="H" />
                            </div>


                            {/* Transaction Details */}
                            <div className="d-flex flex-column gap-4 ">
                                {/* Total pagado y Autorización */}
                                <div className="row g-3">
                                    <div className="col-6">
                                        <p className="text-muted fw-light mb-1">{isPointsPayment ? "Total de puntos" : "Total de la orden"}</p>
                                        <p className="text-dark fw-semibold fs-5 mb-0" translate='no'>{isPointsPayment ? pointsLabel : `$${total.toFixed(2)}`}</p>
                                    </div>

                                    {!isPointsPayment && invoiceTips > 0 ? <>
                                        <div className="col-6">
                                            <p className="text-muted fw-light mb-1">Propina</p>
                                            <p className="text-dark fw-semibold mb-0" translate='no'>${invoiceTips.toFixed(2)}</p>
                                        </div>


                                        < div className='col-12'>
                                            {/* Divider */}
                                            <div className="border-bottom border-1 border-dashed-bs border-gray-300-bs"></div>

                                        </div>
                                        <div className='col-12'>
                                            <div className='d-flex align-items-center justify-content-between '>
                                                <p className="text-muted fw-light mb-1">Total pagado</p>
                                                <p className="text-dark fw-semibold mb-0" translate='no'>${totaltopay.toFixed(2)}</p>
                                            </div>
                                        </div>
                                    </>
                                        : ""}

                                    {!isPointsPayment && change > 0 ? <>
                                        <div className='col-12'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <p className="fw-light text-danger">Total del cambio: </p>
                                                <p className="fw-semibold text-danger" translate='no'>${change}</p>
                                            </div>
                                        </div>
                                    </> : ""}
                                </div>
                            </div>



                            <div className='row d-flex justify-content-center w-100 mb-3'>
                                <div className="col-sm-12 p-2 d-flex flex-column align-items-center">
                                    <label className="form-label fw-bold mb-1">
                                        <i className="uil uil-at"></i> Correo electrónico
                                    </label>
                                    <div className="input-group w-100" style={{ maxWidth: 350 }}>
                                        <input
                                            type="email"
                                            className={`form-control rounded-start border-1 text-muted ${email && !/^([^@\s]+)@([^@\s]+)\.[^@\s]+$/.test(email) ? 'is-invalid' : ''}`}
                                            placeholder="ejemplo@correo.com"
                                            value={email || ''}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            autoFocus
                                        />

                                        {user?.email ? (
                                            <div className="w-100 d-flex flex-column align-items-center mt-2">
                                                <div
                                                    className="form-check w-100"
                                                    style={{ maxWidth: 350 }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="copy-me-email"
                                                        checked={copyMe}
                                                        onChange={(e) => setCopyMe(e.target.checked)}
                                                    />

                                                    <label
                                                        className="form-check-label text-muted"
                                                        htmlFor="copy-me-email"
                                                    >
                                                        Enviar copia (CC)
                                                    </label>
                                                </div>

                                                {copyMe && (
                                                    <div
                                                        className="input-group mt-2"
                                                        style={{ maxWidth: 350 }}
                                                    >
                                                        <span className="input-group-text">
                                                            CC
                                                        </span>

                                                        <input
                                                            type="email"
                                                            className={`form-control ${ccEmail &&
                                                                    !/^([^@\s]+)@([^@\s]+)\.[^@\s]+$/.test(ccEmail)
                                                                    ? 'is-invalid'
                                                                    : ''
                                                                }`}
                                                            value={ccEmail}
                                                            placeholder="correo@empresa.com"
                                                            onChange={(e) => setCcEmail(e.target.value)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        ) : null}
                                        {dataClientSelected?.email ? <><button
                                            className="btn btn-warning rounded-end d-flex align-items-center gap-1"
                                            style={{ minWidth: 110 }}
                                            disabled={!email || !/^([^@\s]+)@([^@\s]+)\.[^@\s]+$/.test(email)}
                                            onClick={() => formatDataEmail(email, undefined, undefined, copyMe ? ccEmail : null)}
                                        >
                                            <span><i className="uil uil-fast-mail-alt"></i></span>
                                            <span>Reenviar</span>
                                        </button></> : <><button
                                            className="btn btn-primary rounded-end d-flex align-items-center gap-1"
                                            style={{ minWidth: 110 }}
                                            disabled={!email || !/^([^@\s]+)@([^@\s]+)\.[^@\s]+$/.test(email)}
                                            onClick={() => formatDataEmail(email, undefined, undefined, copyMe ? ccEmail : null) }
                                        >
                                            <span><i className="uil uil-fast-mail-alt"></i></span>
                                            <span>Enviar</span>
                                        </button></>}

                                    </div>
                                    {email && !/^([^@\s]+)@([^@\s]+)\.[^@\s]+$/.test(email) && (
                                        <div className="invalid-feedback d-block text-center mt-1">
                                            Ingresa un correo válido.
                                        </div>
                                    )}
                                </div>

                                {sendStatus == true ? <>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <div className="alert alert-success text-center w-100 mt-2">
                                            <i className="uil uil-check-circle text-success"></i> El comprobante fue enviado al correo <b>{email}</b>.
                                        </div></div>
                                </> : <>
                                </>}
                            </div>

                            <div className="d-flex  align-items-center justify-content-center gap-1">

                                <RenderIf isTrue={microsModule === 1}>
                                    <button className='btn btn-blue w-100 py-2 rounded-pill' onClick={() => printOrder(order_id, datatransaction_code, true)}>
                                        Imprimir en quiosco
                                    </button>
                                </RenderIf>



                                <button className='btn btn-teal w-100  py-2 rounded-pill' onClick={() => newOrder()}>Nueva orden </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>)
    }



    return (
        <>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                backdrop="static"
                centered
                size='lg'
            >

                <Modal.Body className='p-0 m-0 bg-transparent'>
                    <div class="row g-0 modal-grid">
                        {/* <!-- 🧾 COLUMNA IZQUIERDA (TU ÁREA DE CUENTAS) --> */}
                        {videoList.length > 0 ? <><div class="col-12 col-lg-6 accounts-area p-3 d-flex  align-items-center justify-content-center">{detailsOrder()}</div>  <div class="col-12 col-lg-6 video-area  ">
                            {videoView()}
                        </div></> : <><div class="col-12 col-lg- accounts-area p-3 d-flex  align-items-center justify-content-center">{detailsOrder()}</div></>}

                    </div>
                </Modal.Body>
            </Modal >


        </>
    )
}

export default ModalConfirmation
